<template>
    <div class="wennoAr">
        <el-image v-if="imgShow"
            style="width: 100%;display: block;" :src="$store.state.isPC?require('@/assets/img/mask1.png'):require('@/assets/img/mask1_1.png')"
            fit="contain">
        </el-image>
        <div :class="imgShow?'arContent':'arContentLine'">
            <div class="arTitle fontPB" v-if="imgShow">{{$t('product.whyar')}}</div>
            <div class="arGroup">
                <div class="arGroupL">
                    <div class="leftText fontPL">{{$t('product.whyarl')}}</div>
                    <div class="videoBox">
                        <el-image
                            class="videoBg"
                            :src="require('@/assets/img/phone.png')"
                            fit="contain">
                        </el-image>
                        <template v-if="medias[0]">
                            <template v-if="medias[0].type==1">
                                <video class="videoContent" style="background: #333;border-radius: 8px;" :src="medias[0].media" controls="controls">
                                    {{$t('product.whyarerr')}}
                                </video>
                            </template>
                            <template v-else>
                                <el-image class="videoContent" :src="medias[0].media" fit="contain"></el-image>
                            </template>
                        </template>
                        <template v-else>
                            <div class="videoContent">
                                {{$t('shop.noData')}}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="arGroupR">
                    <div class="videoBox">
                        <el-image
                            class="videoBg"
                            :src="require('@/assets/img/phone.png')"
                            fit="contain">
                        </el-image>
                        <template v-if="medias[1]">
                            <template v-if="medias[1].type==1">
                                <video class="videoContent" style="background: #333;border-radius: 8px;" :src="medias[1].media" controls="controls">
                                    {{$t('product.whyarerr')}}
                                </video>
                            </template>
                            <template v-else>
                                <el-image class="videoContent" :src="medias[1].media" fit="contain"></el-image>
                            </template>
                        </template>
                        <template v-else>
                            <div class="videoContent">
                                {{$t('shop.noData')}}
                            </div>
                        </template>
                    </div>
                    <div class="rightText fontPL">{{$t('product.whyarr')}}</div>
                </div>
            </div>
        </div>
    </div>	
</template>

<script>
export default {
    props:['imgShow'],
	data () {
		return {
            medias:[],
		}
	},
	mounted(){
        this.getMedias();
	},
	methods:{
        getMedias(){
            this.$axios({
                method: 'get',
                url:'/api/medias?location=20',
            }).then(res => {
                console.log(res);
                this.medias=res.data;
            }).catch(error=>{
                
            });
        },
	}
}
</script>
<style scoped>
	/*wennoAr*/
    .wennoAr{
        width: 100%;height: auto;position: relative;
    }
    .arTitle{
        width: 100%;height: 100px;line-height: 100px;
        font-size: 50px;color: #FC4C86;text-align: center;margin:30px 0;
    }
    .arGroup{
        width: 100%;display: flex;justify-content: space-between;
    }
    .arGroupL,.arGroupR{
        width:50%;display: flex;justify-content: space-between;
        align-items: center;
    }
    .videoBox{
        width: 44%;margin: 0 1%;position: relative;
    }
    .videoBox .videoBg{
        width: 100%;display: block;
    }
    .videoContent{
        width: 80%;height: 80%;text-align: center;
        position: absolute;z-index: 2;left: 10%;top: 10%;
    }
    .leftText{
        line-height: 30px;font-size: 24px;color: #7B5C55;width: 34%;margin-left: 18%;
        padding-right:24px;
    }
    .rightText{
        line-height: 35px;font-size: 24px;color: #7B5C55;width: 34%;margin-right: 18%;
        padding-left:24px;
    }
	/*手机*/
    @media screen and (max-width: 768px){
    	/*wennoAr*/
        .arContent{
            width: 90%;
            position: absolute;
            left: 5%;
            top: 0;
            height: 100%;
        }
        .arContentLine{
            width: 90%;
            margin:0 auto 20px;
            height: 100%;
        }
        .arTitle{
            font-size: 25px;
            height:50px;line-height:50px;margin: 10px 0;
        }
        .arGroup{display:block;}
        .arGroupL{width:100%;flex-direction: row;align-items: center;margin-bottom:20px;}
        .arGroupR{width:100%;flex-direction: row;align-items: center;}

        .videoBox{
            width: 40%;position: relative;margin: 0 auto;
        }
        .videoBox .videoBg{
            width: 100%;display: block;
        }
        .videoContent{
            position: absolute;width: 80%;height: auto;z-index: 2;left: 10%;top: 10%;
        }
        .leftText{
            line-height: 20px;font-size: 16px;color: #7B5C55;
            width: 50%;margin-left: 0%;text-align:right;padding-right:16px;
        }
        .rightText{
            line-height: 20px;font-size: 16px;color: #7B5C55;
            width: 50%;margin-right: 0%;text-align:left;padding-left:16px;
        }
    }
    /*平板*/
    @media screen and (min-width: 768px) and (max-width: 992px){
		/*wennoAr*/
        .arContent{
            width: 90%;
            position: absolute;
            left: 5%;
            top: 0;
            height: 100%;
        }
        .arContentLine{
            width: 90%;
            margin:0 auto 20px;
            height: 100%;
        }
        .arGroup{
            width: 100%;display: flex;justify-content: space-between;
        }
        .arGroupL{
            width:50%;display: flex;justify-content: space-between;
            align-items: center;margin-bottom:10px;
        }
        .arGroupR{
            width:50%;display: flex;justify-content: space-between;
            align-items: center;margin-bottom:10px;
        }
        .arTitle{
            font-size: 42px;height:70px;line-height:70px;margin:20px 0;
        }
        .videoBox{
            width: 40%;margin: 0 auto;position: relative;
        }
        .videoContent{
            position: absolute;width: 80%;height: 80%;z-index: 2;left: 10%;top: 10%;
        }
        .leftText{
            line-height: 24px;font-size: 18px;color: #7B5C55;width: 50%;margin-left: 10%;padding-right:18px;
        }
        .rightText{
            line-height: 24px;font-size: 18px;color: #7B5C55;width: 50%;margin-right: 10%;padding-left:18px;
        }
    }
    /*中等屏幕*/
    @media screen and (min-width: 992px) and (max-width: 1200px){
    	/*wennoAr*/
        .arContent{
            width: 90%;
            position: absolute;
            left: 5%;
            top: 0;
            height: 100%;
        }
        .arContentLine{
            width: 90%;
            margin:0 auto 25px;
            height: 100%;
        }
        .arTitle{
            font-size: 46px;height:80px;line-height:80px;margin:20px 0;
        }
        .videoBox{
            width: 44%;margin: 0 1%;position: relative;
        }
        .videoContent{
            position: absolute;width: 80%;height: 80%;z-index: 2;left: 10%;top: 10%;
        }
        .leftText{
            line-height: 28px;font-size: 20px;color: #7B5C55;width: 36%;margin-left: 16%;padding-right:20px;
        }
        .rightText{
            line-height: 28px;font-size: 20px;color: #7B5C55;width: 36%;margin-right: 16%;padding-left:20px;
        }
    }
    /*大屏幕*/
    @media screen and (min-width: 1200px){
        .arContent{
            width: 90%;position: absolute;left: 5%;top: 0;height: 100%;
        }
        .arContentLine{
            width: 90%;
            margin:0 auto 25px;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/DetailVr.vue